import { render, staticRenderFns } from "./StandardWatch.vue?vue&type=template&id=3a135110"
import script from "./StandardWatch.vue?vue&type=script&lang=js"
export * from "./StandardWatch.vue?vue&type=script&lang=js"
import style0 from "./StandardWatch.vue?vue&type=style&index=0&id=3a135110&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./StandardWatch.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports